import React from "react";
import securityImage from "../../../assets/security.jpg";
import { Link } from "react-router-dom";

const EnsureSecurity = () => {
  const scrollHeader = () => {
    window.scrollTo({ top: 0, behavior: "instant" });
  };
  return (
    <div className="plp-ensure-security-wrapper">
      <div className="security-details">
        <div className="row align-items-center justify-content-between">
          <div className="col-12 col-md-6 col-lg-8 col-xl-6">
            <div className="partnership__infos">
              <h2>How We Ensure Security in Product Line Printing</h2>
              <p className="fs-lead my-4">
                Soori Corporation ensures that sensitive product information
                used in printing processes is handled securely. We utilize
                encrypted data transmission between systems and printers,
                safeguarding proprietary or confidential information from
                unauthorized access during the printing process.
              </p>
              <div className="mt-10x">
                <Link
                  to="/contact-us"
                  className="link-btn btn link-btn--primary"
                  onClick={scrollHeader}
                >
                  <span>Contact Us</span>
                </Link>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <div
              className="justify-content-center d-flex"
              style={{ position: "relative", opacity: 1, transform: "none" }}
            >
              <img src={securityImage} alt="security" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnsureSecurity;
